import ceil from "lodash/ceil";
import startsWith from "lodash/startsWith";
import sampleIcon from "../../icons/16x16/color-picker.svg";
import sampleAdventCalendarMask from "../../samples/customization/advent-calendar-mask.png";
import sampleAdventCalendarNumbers from "../../samples/customization/advent-calendar-numbers.png";
import sampleFrame20x30BlackRotated from "../../samples/customization/frame20x30-black-rotated.jpg";
import sampleFrame20x30Black from "../../samples/customization/frame20x30-black.jpg";
import sampleFrame20x30BlackTransparent from "../../samples/customization/frame20x30-black.png";
import sampleFrame20x30WoodRotated from "../../samples/customization/frame20x30-wood-rotated.jpg";
import sampleFrame20x30Wood from "../../samples/customization/frame20x30-wood.jpg";
import sampleAssetOptionWood from "../../samples/customization/frame_assets_back.png";
import sampleFrozen2 from "../../samples/customization/frozen2.png";
import samplePrintStars from "../../samples/customization/print-stars.png";
import { TemplateAssetDefinition } from "../../types/customization/template";

export function adjustWidth(width: number): number {
  if (width < 100) {
    return 100;
  }

  if (width > 2000) {
    return 2000;
  }

  if (width % 100 === 0) {
    return width;
  }

  return ceil(width / 100) * 100;
}

export function imageUrlFromAssetDefinition(
  assetDefinition: TemplateAssetDefinition,
  width?: number,
  assetUrlTemplate?: string
): string {
  const { assetId } = assetDefinition;

  if (startsWith(assetId, "sample://")) {
    // Used for Samples
    if (assetId === "sample://asset_option_wood.png") {
      return sampleAssetOptionWood;
    }
    if (assetId === "sample://advent-calendar-mask.png") {
      return sampleAdventCalendarMask;
    }
    if (assetId === "sample://advent-calendar-numbers.png") {
      return sampleAdventCalendarNumbers;
    }
    if (assetId === "sample://print-stars.png") {
      return samplePrintStars;
    }
    if (assetId === "sample://frame20x30-black.jpg") {
      return sampleFrame20x30Black;
    }
    if (assetId === "sample://frame20x30-black.png") {
      return sampleFrame20x30BlackTransparent;
    }
    if (assetId === "sample://frame20x30-black-rotated.jpg") {
      return sampleFrame20x30BlackRotated;
    }
    if (assetId === "sample://frame20x30-wood.jpg") {
      return sampleFrame20x30Wood;
    }
    if (assetId === "sample://frame20x30-wood-rotated.jpg") {
      return sampleFrame20x30WoodRotated;
    }
    if (assetId === "sample://frozen2.jpg") {
      return sampleFrozen2;
    }
    if (assetId === "sample://icon.png") {
      return sampleIcon;
    }

    throw new Error("Unsupported sample");
  } else {
    if (!assetUrlTemplate) {
      throw new Error("Missing assetUrlTemplate in configuration");
    }

    const adjustedWidth = width ? adjustWidth(width) : 1000;

    return assetUrlTemplate
      .replace("[width]", adjustedWidth.toString())
      .replace("[asset_id]", assetId);
  }
}
